import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 44.469 44.597",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44.469 44.597\" id=\"icon-home\">\n  <path d=\"M24.752.927h0a3.56,3.56,0,0,0-4.793,0L.578,19.38h0a1.791,1.791,0,0,0,2.394,2.663l.308-.293V41.008h0A3.581,3.581,0,0,0,6.852,44.6h10.41V33.8h0a2.521,2.521,0,0,1,2.514-2.528h4.9A2.521,2.521,0,0,1,27.2,33.8s0,0,0,0V44.6H37.849a3.581,3.581,0,0,0,3.577-3.584s0,0,0-.006V21.984a1.8,1.8,0,0,0,2.582-.073h0a1.8,1.8,0,0,0-.129-2.532h0L24.752.929Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol